import utils from 'utils';
class enterpriseReportQueryCtrl {
  constructor(
    $scope,
    httpRequest,
    $state,
    $stateParams,
    sweetalert,
    logger,
    tableQueryConfigERQ,
    $timeout,
    authService,
    $filter,
    Upload,
    $uibModal,
    $http
  ) {
    $scope.currentUserInfo = JSON.parse(localStorage.user_info).user;
    $scope.select = {}
    $scope.treeConfig = {
        isCheckall: true,
        check: {
            //如果没有设置配置项，取默认配置
            enable: true, //显示不显示复选框
            chkboxType: { Y: '', N: '' },
        },
    }
    $scope.importBtnCollapsed = false;
    // 勾选的数据
    $scope.selectedRows = [];
    // 查询的参数
    $scope.queryParam = {
      pageSize: 10,
      pageNum: 1,
      param: {
        quarter: utils.getQuarter(),
        companyName: '',
        creditCode: '',
        declarationFillInStatus: '',
        declarationStatus: '',
        departmentNo: '',
        managerCityNo: '',
        paymentStatus: '',
        regionNo: '',
        status: '1',
        reportGenerationStatus: '',
      },
    };
    // 重置
    $scope.reset = function () {
      $scope.queryParam.param = {
        quarter: utils.getQuarter(),
        companyName: '',
        creditCode: '',
        declarationFillInStatus: '',
        declarationStatus: '',
        departmentNo: '',
        managerCityNo: '',
        paymentStatus: '',
        regionNo: '',
        status: '1',
        reportGenerationStatus: '',
      };
    //   queryInfo();
    getUserInfo()
    };
    //自动查询展示
    const queryInfo = function queryInfo() {
      const openLoading =
        $scope.queryParam.pageSize >= 100
          ? window.layer.msg('正在查询，请耐心等待', {
              time: 0,
              skin: 'layer-loading-self',
              icon: 16,
              shade: 0.5,
            })
          : null;
      httpRequest
        .post_getEnterpriseDeclarationList(queryDataHandle($scope.queryParam))
        .then((res) => {
          $scope.listData = res.data.value.list;
          $scope.totalItems = res.data.value.total;
          $scope.queryParam.pageNum = res.data.value.pageNum;
          $scope.queryParam.pageSize = res.data.value.pageSize;
          $scope.selectedRows = [];
          // console.log($scope.listData)
        })
        .finally(() => {
          window.layer.close(openLoading);
        });
    };
    function queryDataHandle(queryData) {
        $scope.employeeList = []
        const { selectedFollower } = $scope.select
        selectedFollower.forEach(item => {
            $scope.employeeList.push({employeeName:item.employeeName, employeeNumber:item.employeeNumber})
        });
        queryData.param.employeeList = $scope.employeeList

        return queryData
    }
    // 搜索
    $scope.searchList = function () {
      queryInfo();
    };
    // 分页
    $scope.pageChanged = function () {
      // 点击页码发起查询
      queryInfo();
    };
    // 切换税款申报期
    $scope.updateSearch = function () {
      queryInfo();
    };
    // 字典
    $scope.dictData = {};
    const typecodeArrStr = [
      'enterprise_declaration', //申报状态
      'department_no',
      'zzs_status',
    ];
    httpRequest.get_dictByTypeArr(typecodeArrStr).then((res) => {
      $scope.dictData = $.extend($scope.dictData, res.data.value);
    });
    // 主管税局省（市）
    httpRequest
      .get_getAllTaxBureau(localStorage.getItem('id_token'))
      .then((res) => {
        $scope.dictDataProvince = res.data.value;
      });
    // 百丽--获取地区时两个参数都不传，获取管理城市时两个都要传--百丽接口
    httpRequest.get_getBelleRegion().then((res) => {
      $scope.belleRegionList = res.data.value;
    });
    // 获取管理城市时两个都要传
    $scope.$watch('queryParam.param.regionNo', function (newVal, oldVal) {
      //重置
      if ($scope.queryParam.param.regionNo == '') {
        $scope.belleRegionCityList = [];
        return;
      }
      let params = {
        affiliation: $scope.queryParam.param.departmentNo,
        regionNo: $scope.queryParam.param.regionNo,
      };
      if (params.affiliation == '' || params.regionNo == '') return;
      httpRequest.get_getBelleRegion(params).then((res) => {
        $scope.belleRegionCityList = res.data.value;
      });
    });
    // queryInfo();
    $scope.queryInfo = queryInfo;
    // 单个下载
    $scope.downloadFile = function (v, data) {
      if (data.mongoId == null && v==1) {
        logger.logTips('RPA正在税局下载申报表，请稍作等待', 'warn');
        return;
      }
      if (data.cwbbMongoId == null && v==2) {
        logger.logTips('RPA正在税局下载财务报表，请稍作等待', 'warn');
        return;
      }
    //   if (
    //     Number(data.declarationStatus) != 2 &&
    //     Number(data.declarationStatus) != 3
    //   ) {
    //     logger.logError(
    //       '申报状态为“申报成功”或"人工申报成功"的报表才允许下载，请检查'
    //     );
    //     return;
    //   }
      let applyPeriodTime = $scope.queryParam.param.quarter;
      let url = `${host.etcloudIvatApp}taxdeclaration/rpaStampDutyResult/downSbFile`;
      let params = {
        sbDownListDtos: [
          {
            mongoId: v == 1 ? data.mongoId : data.cwbbMongoId,
            id: data.id,
            applyperiod: applyPeriodTime,
            taxNo: data.taxNo,
          },
        ],
      };
      let fileName;
      if (v == 1) {
        fileName = data.fileName;
      } else {
        fileName = data.cwbbFileName;
      }
      utils.declarefile_download(url, fileName, 'POST', 'blob', params, false);
      queryInfo();
    };
    // 批量下载
    $scope.batchDownload = function (v) {
      if (!$scope.selectedRows.length) {
        return logger.logError('请选择数据后操作');
      }
      //选择一个的时候单个下载
      if ($scope.selectedRows.length == 1) {
        $scope.downloadFile(v, $scope.selectedRows[0]);
        return;
      }
      // 可下载的集合
      $scope.newSelectedRows = [];
      angular.forEach($scope.selectedRows, function (item, index) {
        if (
          (Number(item.declarationStatus) == 2 ||
            Number(item.declarationStatus) == 3) &&
          item.mongoId != null
        ) {
          $scope.newSelectedRows.push(
            v == 1 ? item : $.extend(item, { mongoId: item.cwbbMongoId })
          );
        }
      });
      if ($scope.newSelectedRows.length == 0) {
        logger.logError('选择的数据暂时没有附件或申报状态不符合，请检查');
        return;
      }
      let quarter = $scope.queryParam.param.quarter;
      let resetFileName;
      if (v == 1) {
        resetFileName = '纳税申报表' + quarter.replace('-', '');
      } else {
        resetFileName = '财务报表' + quarter.replace('-', '');
      }
      //传参要求
      //  sbDownListDtos: {
      //     "applyperiod":"string",
      //     "id":"string",
      //     "mongoId":"string",
      //     "taxNo":"string"
      // }
      let params = {
        enclosure: resetFileName,
        sbDownListDtos: $scope.newSelectedRows,
      };
      let url = `${host.etcloudIvatApp}taxdeclaration/rpaStampDutyResult/downSbFile`;
      utils.declarefile_download(
        url,
        resetFileName,
        'POST',
        'blob',
        params,
        true
      );
      queryInfo();
    };
    //导出
    $scope.exportExel = function exportExel() {
      let fileName =
        '申报表查询(企业所得税)_' + $scope.queryParam.param.quarter;
      let url = `${
        host.etcloudIvatApp
      }taxdeclaration/rpaGsTask/exportList?accessToken=${localStorage.getItem(
        'id_token'
      )}`;
      utils.file_download(
        url,
        $scope.queryParam.param,
        'enterprise_result', //type
        'POST',
        'blob',
        fileName,
        false
      );
    };
    // 查询字段设置
    $scope.customizedConfig = tableQueryConfigERQ;
    function getUserInfo() {
        $scope.params = {
            pageSize: 2000,
            pageNum: 1,
            param: {
                isRoleOwner: '1', // 拥有本机构角色
                orgIdList: [JSON.parse(localStorage.user_info).org.orgId], // 所属机构
            },
        }
        httpRequest.get_getIvatEmployeeList($scope.params).then((res) => {
            $scope.followerList = dataHandle(res.data.value)
            $scope.select.selectedFollower =  $scope.followerList.filter((x) => { return x.employeeName == $scope.currentUserInfo.realName})
            queryInfo()
        })
    }
    getUserInfo()
    function dataHandle(list) {
        list.forEach((el,index) => {
            el.orgId = index
            el.orgName = el.employeeName + '|' + el.employeeNumber
            if ($scope.currentUserInfo.realName == el.employeeName) {
                el.checked = true
            } else {
                el.checked = false
            }
        })
        return list
    }
  }
}
enterpriseReportQueryCtrl.$inject = [
  '$scope',
  'httpRequest',
  '$state',
  '$stateParams',
  'sweetalert',
  'logger',
  'tableQueryConfigERQ',
  '$timeout',
  'authService',
  '$filter',
  'Upload',
  '$uibModal',
  '$http',
];
export default enterpriseReportQueryCtrl;



// WEBPACK FOOTER //
// ./src/app/declaration/corporateIncomeTax/enterpriseReportQuery/enterpriseReportQueryCtrl.js